module.exports = "/images/sold_out.png";